import { render, staticRenderFns } from "./ETSDetails.vue?vue&type=template&id=29fa6a2f&scoped=true&"
import script from "./ETSDetails.vue?vue&type=script&lang=js&"
export * from "./ETSDetails.vue?vue&type=script&lang=js&"
import style0 from "./ETSDetails.vue?vue&type=style&index=0&id=29fa6a2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fa6a2f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCard,VChip})
